import React from 'react';
import { useLanguage, t } from '../context/LanguageContext';

export default function TraceabilitySearchPanel({
  ingredientCode, onIngredientCodeChange, onIngredientSearch, onIngredientClear, isIngredientActive,
  ingredientNameInput, onIngredientNameChange, onIngredientNameSearch, onIngredientNameClear, isIngredientNameActive,
  batchLotCodeInput, onBatchLotCodeChange, onBatchSearch, onBatchClear, isBatchSearchActive,
  lotSearchValue, productSearchValue, customerSearchValue, onLotSearchChange, onProductSearchChange, onCustomerSearchChange,
}) {
  const { lang } = useLanguage();
  const filterIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
      <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
    </svg>
  );

  return (
    <div className="mb-4">

      {/* Row 1 — Search inputs */}
      <div className="row g-2 mb-2">
        <div className="col-12 col-md-4">
          <label className="form-label small fw-semibold mb-1">{t('Ingredient Lot Code', 'Código de Lote de Ingrediente', lang)}</label>
          <div className="input-group">
            <input
              type="text"
              className={`form-control${isIngredientActive ? ' border-primary' : ''}`}
              placeholder={t('Search by ingredient lot code…', 'Buscar por código de lote de ingrediente…', lang)}
              value={ingredientCode}
              onChange={e => onIngredientCodeChange(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && !isIngredientActive && onIngredientSearch()}
            />
            {isIngredientActive ? (
              <button className="btn btn-outline-secondary" onClick={onIngredientClear}>{t('Clear', 'Limpiar', lang)}</button>
            ) : (
              <button className="btn btn-primary" onClick={onIngredientSearch}>{t('Search', 'Buscar', lang)}</button>
            )}
          </div>
        </div>

        <div className="col-12 col-md-4">
          <label className="form-label small fw-semibold mb-1">{t('Ingredient Name', 'Nombre del Ingrediente', lang)}</label>
          <div className="input-group">
            <input
              type="text"
              className={`form-control${isIngredientNameActive ? ' border-primary' : ''}`}
              placeholder={t('Search by ingredient name…', 'Buscar por nombre de ingrediente…', lang)}
              value={ingredientNameInput}
              onChange={e => onIngredientNameChange(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && !isIngredientNameActive && onIngredientNameSearch()}
            />
            {isIngredientNameActive ? (
              <button className="btn btn-outline-secondary" onClick={onIngredientNameClear}>{t('Clear', 'Limpiar', lang)}</button>
            ) : (
              <button className="btn btn-primary" onClick={onIngredientNameSearch}>{t('Search', 'Buscar', lang)}</button>
            )}
          </div>
        </div>

        <div className="col-12 col-md-4">
          <label className="form-label small fw-semibold mb-1">{t('Batch Lot Code', 'Código de Lote de Producción', lang)}</label>
          <div className="input-group">
            <input
              type="text"
              className={`form-control${isBatchSearchActive ? ' border-primary' : ''}`}
              placeholder={t('Search by batch lot code…', 'Buscar por código de lote de producción…', lang)}
              value={batchLotCodeInput}
              onChange={e => onBatchLotCodeChange(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && !isBatchSearchActive && onBatchSearch()}
            />
            {isBatchSearchActive ? (
              <button className="btn btn-outline-secondary" onClick={onBatchClear}>{t('Clear', 'Limpiar', lang)}</button>
            ) : (
              <button className="btn btn-primary" onClick={onBatchSearch}>{t('Search', 'Buscar', lang)}</button>
            )}
          </div>
        </div>
      </div>

      {/* Row 2 — Filters */}
      <div className="row g-2">
        <div className="col-12 col-md-4">
          <div className="input-group">
            <span className="input-group-text text-muted" style={{ fontSize: 13 }}>{filterIcon}</span>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={t('Filter by lot code…', 'Filtrar por código de lote…', lang)}
              value={lotSearchValue}
              onChange={onLotSearchChange}
            />
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="input-group">
            <span className="input-group-text text-muted" style={{ fontSize: 13 }}>{filterIcon}</span>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={t('Filter by product name…', 'Filtrar por nombre de producto…', lang)}
              value={productSearchValue}
              onChange={onProductSearchChange}
            />
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="input-group">
            <span className="input-group-text text-muted" style={{ fontSize: 13 }}>{filterIcon}</span>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={t('Filter by customer…', 'Filtrar por cliente…', lang)}
              value={customerSearchValue}
              onChange={onCustomerSearchChange}
            />
          </div>
        </div>
      </div>

    </div>
  );
}
